__turbopack_context__.v({
  "rightGroup": "PriceBar-module__fn2KDG__rightGroup",
});
